import { useCallback } from "react"
import { useAppLocalization } from "../../modules/localization/components/AppLocalizationProvider"
import { AppError, ErrorDisplay } from "./errorTypes"
import { enqueueError } from "../../shared/components/errors/store/errorSlice"
import { useAppDispatch } from "../../modules/store/storeHooks"

export function useApiErrorHandling() {
    const { l10n } = useAppLocalization()
    const dispatch = useAppDispatch()

    const handleError = useCallback(
        (error: unknown, errorDisplay: ErrorDisplay) => {
            let appError: AppError
            if (error instanceof AppError) {
                appError = error
            } else {
                const cause = error instanceof Error ? error : undefined
                const title = l10n.getString("api-call-error-title-unknown-error")
                const message = l10n.getString("api-call-error-unknown-error")
                appError = new AppError("E_API_ERROR", title, message, cause)
            }

            dispatch(
                enqueueError({
                    display: errorDisplay,
                    error: appError,
                }),
            )
        },
        [dispatch],
    )

    return { handleError }
}
